var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGleapbot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8084 24.3655C19.0386 27.7235 17.8272 32.2313 17.8272 36.549C17.8272 40.8667 19.0387 45.3745 21.8084 48.7325C24.4815 51.9731 28.8832 54.4884 36.0927 54.4884C43.6939 54.4884 47.4788 51.2011 49.4695 48.0756C50.87 45.8767 51.3717 44.2697 51.5516 43.187C51.6719 42.4626 52.2576 41.8645 53.0049 41.8645H57.0638C57.8113 41.8645 58.4256 42.4595 58.3618 43.1907C58.1941 45.1148 57.5468 47.9225 55.2048 51.5992C52.0702 56.5209 46.195 61.1326 36.0927 61.1326C27.0662 61.1326 20.6439 57.8757 16.552 52.9149C12.5568 48.0714 11.0623 41.9484 11.0623 36.549C11.0622 31.1496 12.5567 25.0266 16.5519 20.1831C20.4362 15.4741 26.4202 12.3004 34.7384 11.9903C35.4851 11.9625 36.0927 12.5603 36.0927 13.2942V17.2808C36.0927 18.0147 35.4862 18.6058 34.7399 18.6402C28.3256 18.9352 24.31 21.3327 21.8084 24.3655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4457 28.5758C60.4457 31.5115 58.0227 33.8912 55.0337 33.8912C52.0449 33.8912 49.6219 31.5115 49.6219 28.5758C49.6219 25.6402 52.0449 23.2605 55.0337 23.2605C58.0227 23.2605 60.4457 25.6402 60.4457 28.5758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 51,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGleapbot);
export default __webpack_public_path__ + "static/media/gleapbot.4266e3dccabc58b1ec42e8768de73abe.svg";
export { ForwardRef as ReactComponent };